/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import { produce } from "immer";
import DatePicker from "main/components/DatePicker/DatePicker";
import TimePicker from "main/components/DatePicker/TimePicker";
import { authRoles } from "navigation/route-config";
import React, { useEffect, useState } from "react";
import ScrollBar from "react-perfect-scrollbar";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getCustomers } from "../../../services/CustomerService";
import {
  createJob,
  getAllInspectors,
} from "../../../services/InspectionService";
import { getPropertyByCustomer } from "../../../services/PropertyService";
import CheckBoxModal from "../../components/CheckBox";
import ViewModal from "../../components/CheckBox/ViewModal";
import CustomInput from "../../components/Custom/CustomInput";
import { getAddress, getErrorMsg, showToast } from "../../shared/helpers";
import "./style.css";

const AddInspection = () => {
  const navigate = useNavigate();

  //Customers
  const [customers, setCustomers] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [customerPage, setCustomerPage] = useState(1);
  const [customerLoader, setCustomerLoader] = useState(false);

  const loadCustomers = (page = customerPage, append = false) => {
    setCustomerLoader(true);
    getCustomers("", page)
      .then((res) => {
        if (append && res.data?.data) {
          setCustomers((prev) => ({
            ...res.data,
            data: [...(prev?.data || []), ...(res.data.data || [])],
          }));
        } else {
          setCustomers(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setCustomerLoader(false));
  };

  useEffect(() => {
    loadCustomers();
  }, []);

  // When modal opens, always reset to page 1 and load page 1 so we don't show stale page 2
  useEffect(() => {
    if (showModal) {
      setCustomerPage(1);
      loadCustomers(1, false);
    }
  }, [showModal]);

  useEffect(() => {
    if (showModal && customerPage > 1) {
      loadCustomers(customerPage, true);
    }
  }, [customerPage]);

  //propperty
  const [proplink, setproplink] = useState(false);
  const [proploader, setproploader] = useState(true);
  const [propdata, setpropdata] = useState(false);
  const [proppage, setproppage] = useState(1);

  const { customerId, customerName, propertyId, propertyAdd } = useParams();

  useEffect(() => {
    if (customerId && customerName && propertyId && propertyAdd) {
      setpay(
        produce(pay, (draftState) => {
          draftState.customer = customerId;
          draftState.customerDisplayName = customerName;
          draftState.property = propertyId;
        })
      );
    }
  }, [customerId, customerName, propertyId, propertyAdd]);

  const propopen = () => {
    if (proppage === 1) {
      setpropdata(null);
    }
    setproplink(true);
    setproploader(true);
    getPropertyByCustomer(pay.customer, proppage)
      .then(({ data: res }) => {
        setpropdata(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setproploader(false));
  };

  //Inspectors
  const [inspectlink_view, setinspectlink_view] = useState(false);
  const [inspectloader_view, setinspectloader_view] = useState(true);
  const [inspectdata_view, setinspectdata_view] = useState(false);
  const [, setinspectpage_view] = useState(1);
  const inspectopen_view = () => {
    setinspectdata_view(null);
    setinspectlink_view(true);
    setinspectloader_view(false);
  };

  //Inspectors
  const [inspectlink, setinspectlink] = useState(false);
  const [inspectloader, setinspectloader] = useState(true);
  const [inspectdata, setinspectdata] = useState(false);
  const [inspectpage, setinspectpage] = useState(1);
  const inspectopen = () => {
    if (inspectpage === 1) {
      setinspectdata(null);
    }
    setinspectlink(true);
    setinspectloader(true);
    getAllInspectors("", inspectpage)
      .then(({ data: res }) => {
        setinspectdata(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setinspectloader(false));
  };

  //main
  const [isSubmit, setisSubmit] = useState(false);
  const [errors, seterrors] = useState({});
  const [disbutton, setdisbutton] = useState(false);
  const user = useSelector((state) => state.user.data);
  const [pay, setpay] = useState({
    date: "",
    time: "",
    notes: "",
    scheduled_time: "",
    customer: "",
    customerDisplayName: "",
    property: "",
    inspectors: [],
  });

  const getSelectedInspectors = () => {
    const selectedInspectors =
      inspectdata?.data
        ?.filter((x) => pay.inspectors.includes(x.id))
        .map((x) => ({
          id: x.id,
          name: x.first_name + " " + x.last_name,
          image: x.inspector_details?.avatar_url,
        })) ?? [];

    // Only add logged-in inspector if they're selected and not already in the list
    if (
      user.role === authRoles.buInspector &&
      pay.inspectors.includes(user.id)
    ) {
      const isAlreadyInList = selectedInspectors.some((x) => x.id === user.id);
      if (!isAlreadyInList) {
        selectedInspectors.push({
          id: user.id,
          name: user.first_name + " " + user.last_name,
          image: user.inspector_details?.avatar_url,
        });
      }
    }

    return selectedInspectors;
  };

  const getInspectorNames = () => {
    const inspectorNames =
      inspectdata?.data
        ?.filter((x) => pay.inspectors.includes(x.id))
        .map((xd) => {
          return `${xd.first_name + " " + xd.last_name}`;
        }) ?? [];

    // Only add logged-in inspector if they're selected and not already in the list
    if (
      user.role === authRoles.buInspector &&
      pay.inspectors.includes(user.id)
    ) {
      const isAlreadyInNames = inspectdata?.data?.some(
        (x) => x.id === user.id && pay.inspectors.includes(x.id)
      );
      if (!isAlreadyInNames) {
        inspectorNames.push(user.first_name + " " + user.last_name);
      }
    }

    return inspectorNames.join(", ");
  };

  const getInspectorItems = () => {
    const items =
      inspectdata?.data?.map((x) => ({
        id: x.id,
        name: x.first_name + " " + x.last_name,
        image: x.inspector_details?.avatar_url,
      })) ?? [];

    // Add logged-in inspector if they're a buInspector and not already in the list
    if (user.role === authRoles.buInspector) {
      const isAlreadyInList = items.some((item) => item.id === user.id);
      if (!isAlreadyInList) {
        items.unshift({
          id: user.id,
          name: user.first_name + " " + user.last_name,
          image: user.inspector_details?.avatar_url,
        });
      }
    }

    return items;
  };

  useEffect(() => {
    // Only auto-select logged-in inspector on initial load
    if (user.role === authRoles.buInspector && pay.inspectors.length === 0) {
      setpay((s) => ({ ...s, inspectors: [user.id] }));
    }
  }, [user]);

  // Trigger API call when inspector page changes
  useEffect(() => {
    if (inspectlink && inspectpage > 1) {
      inspectopen();
    }
  }, [inspectpage]);

  // Trigger API call when property page changes
  useEffect(() => {
    if (proplink && proppage > 1) {
      propopen();
    }
  }, [proppage]);

  const submit = () => {
    setisSubmit(true);
    if (
      pay.date &&
      pay.time &&
      pay.inspectors &&
      pay.property &&
      pay.notes &&
      pay.customer
    ) {
      setdisbutton(true);
      let data = {
        ...pay,
        scheduled_time:
          dayjs(pay.date).format("MM/DD/YY") +
          " " +
          dayjs(pay.time).format("HH:mm"),
      };
      delete data.date;
      delete data.time;

      createJob(data)
        .then((res) => {
          showToast("Inspection created successfully.", true);
          const envValue = process.env.REACT_APP_LEAD_BUSINESS_UNIT_IDS || "";
          const leadBusinessUnitIds = envValue
            ? envValue
                .split(",")
                .map((id) => id.trim())
                .filter(Boolean)
            : [];

          // Debug logging
          console.log(
            "REACT_APP_LEAD_BUSINESS_UNIT_IDS:",
            process.env.REACT_APP_LEAD_BUSINESS_UNIT_IDS
          );
          console.log("leadBusinessUnitIds:", leadBusinessUnitIds);
          console.log("user.business_unit?.id:", user.business_unit?.id);
          console.log("pay.inspectors:", pay.inspectors);
          console.log("user.id:", user.id);

          const isLeadWithMatchingBU =
            (user.business_unit?.id &&
              leadBusinessUnitIds.includes(String(user.business_unit.id))) ||
            pay.inspectors.includes(user.id);

          console.log("isLeadWithMatchingBU:", isLeadWithMatchingBU);

          if (res?.data?.id && isLeadWithMatchingBU) {
            navigate("/inspections/" + res.data.id);
          } else {
            navigate("/inspections");
          }
        })
        .catch((err) => {
          console.log(err?.response);
          if (err?.response?.status === 422) {
            seterrors(err?.response?.data);
          } else {
            showToast(getErrorMsg(err) || "Unable to create inspection.");
          }
        })
        .finally(() => {
          setdisbutton(false);
        });
    } else {
      const missingFields = [];
      if (!pay.date) missingFields.push("Date");
      if (!pay.time) missingFields.push("Time");
      if (!pay.customer) missingFields.push("Customer");
      if (!pay.property) missingFields.push("Property");
      if (!pay.inspectors || pay.inspectors.length === 0)
        missingFields.push("Inspectors");
      if (!pay.notes) missingFields.push("Notes");

      const errorMessage =
        missingFields.length > 0
          ? `${missingFields.join(", ")} ${
              missingFields.length === 1 ? "is" : "are"
            } required`
          : "All fields are required";

      showToast(errorMessage, false);
    }
  };

  return (
    <div className="main">
      <ScrollBar style={{ height: "calc(100vh - 90px)" }}>
        <div className="main-content-area">
          <div className="d-flex align-items-center justify-content-end">
            <button
              onClick={submit}
              disabled={disbutton}
              className="btn btn-primary ml-auto"
            >
              Save
            </button>
          </div>
          <div>
            <h4>Appointment Details</h4>
            <div className="row">
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-6 " style={{ height: "54px" }}>
                    <DatePicker
                      value={pay.date}
                      setValue={(v) => {
                        setpay(
                          produce(pay, (draftState) => {
                            draftState.date = v;
                          })
                        );
                      }}
                      label="Appointment Date"
                    />
                  </div>

                  <div className="col-md-6" style={{ height: "54px" }}>
                    <TimePicker
                      value={pay.time}
                      setValue={(v) =>
                        setpay(
                          produce(pay, (draftState) => {
                            draftState.time = v;
                          })
                        )
                      }
                      label="Appointment Time"
                    />
                  </div>

                  <div className="col-md-12 mt-5">
                    <div className="form-group">
                      <div className="float-label">
                        <textarea
                          id="additional_remarks"
                          className="form-control input-field"
                          type="text"
                          maxLength="100"
                          value={pay.notes}
                          onChange={(e) =>
                            setpay(
                              // { ...pay, notes: e.target.value }
                              produce(pay, (draftState) => {
                                draftState.notes = e.target.value;
                              })
                            )
                          }
                          style={{ minHeight: "100px" }}
                        />
                        <label
                          className={`${pay.notes !== "" ? "Active " : ""} `}
                          htmlFor="stat"
                        >
                          Notes
                        </label>
                      </div>

                      <small className="text-danger ml-1">
                        {isSubmit && pay.notes === ""
                          ? "Notes cannot be empty"
                          : errors?.notes
                            ? errors?.notes[0]
                            : ""}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-8 mt-5">
                    <h4>Link Customer</h4>
                    <div className="form-group">
                      {!customerId ? (
                        <>
                          <input
                            className="form-control auth-input-field-inspection"
                            style={{
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            placeholder="Choose Customer"
                            value={
                              customerName ||
                              pay.customerDisplayName ||
                              (pay.customer &&
                                customers?.data &&
                                (() => {
                                  const c = customers.data.find(
                                    (x) => x.id === pay.customer
                                  );
                                  return c
                                    ? `${c.first_name || ""} ${c.last_name || ""}`.trim()
                                    : "";
                                })())
                            }
                            onClick={() => setShowModal(!showModal)}
                            type="text"
                            maxLength="15"
                          />
                          <CheckBoxModal
                            items={customers?.data?.map((customer) => ({
                              id: customer.id,
                              name: `${customer.first_name} ${customer.last_name}`,
                            }))}
                            onChecked={(items) => {}}
                            show={showModal}
                            isRadio={true}
                            onHide={() => {
                              setShowModal(false);
                              setCustomerPage(1);
                            }}
                            isAvatar={false}
                            loader={customerLoader}
                            title={"Link Customer"}
                            showTitleIcon={false}
                            buttonLabel={"Link Customer"}
                            emptyText={"No Customer Available"}
                            value={[pay.customer]}
                            onSave={(ev, selectedItems) => {
                              if (ev.length > 0) {
                                setpay(
                                  produce(pay, (draftState) => {
                                    draftState.customer = ev[0] || "";
                                    draftState.customerDisplayName =
                                      selectedItems?.[0]?.name || "";
                                    draftState.property = "";
                                  })
                                );
                              }
                            }}
                            totalItems={customers?.total}
                            currentPage={customerPage}
                            onPageChange={(page) => {
                              setCustomerPage(page);
                            }}
                          />
                        </>
                      ) : (
                        <CustomInput
                          label="Linked Customer"
                          value={customerName}
                          inputProps={{ disabled: true }}
                        />
                      )}
                      <small className="text-danger ml-1">
                        {isSubmit && pay.customer === ""
                          ? "Customer cannot be empty"
                          : errors?.customer
                            ? errors?.customer[0]
                            : ""}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-8 mt-5">
                    <h4>Link Property</h4>
                    <div className="form-group">
                      <input
                        className="form-control auth-input-field-inspection"
                        style={{
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        placeholder="Choose Linked Property"
                        value={
                          propertyAdd ||
                          (pay.property &&
                            getAddress(
                              propdata?.data.find((x) => x.id === pay.property)
                                .address
                            ))
                        }
                        disabled={!pay.customer}
                        type="text"
                        maxLength="15"
                        onClick={propopen}
                      />
                      <CheckBoxModal
                        items={propdata?.data?.map((x) => ({
                          id: x.id,
                          name: getAddress(x.address),
                          image: x.image?.url,
                        }))}
                        onChecked={(items) => {}}
                        show={proplink}
                        isRadio={true}
                        onHide={() => {
                          setproplink(false);
                          setproppage(1);
                        }}
                        isAvatar={true}
                        defaultAvatar={require("../../../assets/icons/house.png")}
                        loader={proploader}
                        title={"Link Property"}
                        showTitleIcon={false}
                        buttonLabel={"Link Property"}
                        emptyText={"No Properties Available"}
                        value={[pay.property]}
                        onSave={(ev) => {
                          if (ev.length > 0) {
                            setpay(
                              // { ...pay, property: ev[0] }
                              produce(pay, (draftState) => {
                                draftState.property = ev[0];
                              })
                            );
                          }
                        }}
                        totalItems={propdata?.total}
                        currentPage={proppage}
                        onPageChange={(page) => {
                          setproppage(page);
                        }}
                      />
                      <small className="text-danger ml-1">
                        {isSubmit && pay.property === ""
                          ? "Property cannot be empty"
                          : errors?.property
                            ? errors?.property[0]
                            : ""}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-8 mt-5">
                    <h4>Inspectors on Site</h4>
                    <div className="form-group">
                      <input
                        className="form-control auth-input-field-inspection"
                        placeholder="Choose Inspector"
                        style={{
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        value={getInspectorNames()}
                        onClick={inspectopen}
                        type="text"
                        maxLength="15"
                      />
                      <CheckBoxModal
                        items={getInspectorItems()}
                        onChecked={(items) => {}}
                        show={inspectlink}
                        onHide={() => {
                          setinspectlink(false);
                          setinspectpage(1);
                        }}
                        isAvatar={true}
                        defaultAvatar={require("../../../assets/icons/person.png")}
                        loader={inspectloader}
                        title={"Add Inspectors"}
                        showTitleIcon={false}
                        buttonLabel={"Save Inspectors"}
                        emptyText={"No Inspectors Available"}
                        value={pay.inspectors}
                        disabledIds={
                          user.is_lead_inspector || user.is_consultant
                            ? []
                            : [user.id]
                        }
                        onSave={(ev) =>
                          setpay(
                            produce(pay, (draftState) => {
                              draftState.inspectors = ev;
                            })
                          )
                        }
                        totalItems={inspectdata?.total}
                        currentPage={inspectpage}
                        onPageChange={(page) => {
                          setinspectpage(page);
                        }}
                      />
                      {pay.inspectors.length > 0 ? (
                        <p></p>
                      ) : (
                        <small className="text-danger ml-1">
                          {isSubmit && pay.inspectors.length < 1
                            ? "Inspectors cannot be empty"
                            : errors?.inspectors
                              ? errors?.inspectors[0]
                              : ""}
                        </small>
                      )}

                      {pay.inspectors.length >= 1 && (
                        <>
                          <div className="d-flex justify-content-end">
                            <div
                              className="view-all-inspectors"
                              onClick={inspectopen_view}
                              style={{ cursor: "pointer" }}
                            >
                              view all
                            </div>
                          </div>
                          <ViewModal
                            items={getSelectedInspectors()}
                            onChecked={(items) => {}}
                            show={inspectlink_view}
                            onHide={() => setinspectlink_view(false)}
                            isAvatar={true}
                            defaultAvatar={require("../../../assets/icons/person.png")}
                            loader={inspectloader_view}
                            title={"View Inspectors"}
                            showTitleIcon={false}
                            buttonLabel={"Close "}
                            applyPagination={true}
                            pagination={inspectdata_view}
                            onPageChange={(page) => {
                              setinspectpage_view(page);
                            }}
                            emptyText={"No Inspectors Available"}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ScrollBar>
    </div>
  );
};

export default AddInspection;
